import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "./data";

export const Testimonials = () => (
    <section data-testid="testimonials-section" className="bg-[#FAF0EC] py-24">
        <div className="mx-auto max-w-6xl px-5">
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#D4AF37]">Testimonials</p>
            <h2 className="mt-3 font-serif text-4xl tracking-tight text-[#2C2A29] sm:text-5xl">
                Loved by brides across Chennai
            </h2>
            <div className="mt-14 grid gap-6 md:grid-cols-2">
                {TESTIMONIALS.map((t, i) => (
                    <motion.div
                        key={t.name}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.45, delay: (i % 2) * 0.1 }}
                        data-testid={`testimonial-card-${i}`}
                        className="rounded-sm border border-[#D4AF37]/20 bg-white p-8 sm:p-10"
                    >
                        <Quote className="h-7 w-7 text-[#E6B8B8]" />
                        <div className="mt-4 flex gap-1" aria-label="5 star review">
                            {Array.from({ length: 5 }).map((_, s) => (
                                <Star key={s} className="h-4 w-4 fill-[#D4AF37] text-[#D4AF37]" />
                            ))}
                        </div>
                        <p className="mt-4 font-serif text-xl italic leading-relaxed text-[#2C2A29]">
                            "{t.quote}"
                        </p>
                        <p className="mt-5 text-sm font-bold text-[#2C2A29]">{t.name}</p>
                        <p className="text-xs uppercase tracking-[0.15em] text-[#5A5652]">{t.location}</p>
                    </motion.div>
                ))}
            </div>
        </div>
    </section>
);
